import React, { useState } from 'react';

import Link from '@/components/switchback/Link/Link';

import css from './CollapsibleRichText.module.css';

const CollapsibleRichText = ({ content: rawContent }) => {
  const content = rawContent.replace('<p>COLLAPSABLE</p>', '');
  const [isFullText, setIsFullText] = useState(false);
  const readMoreText = isFullText ? 'Read less' : 'Read more';

  return (
    <React.Fragment>
      {content && (
        <React.Fragment>
          <div className={`flex mb-8 ${css.maxCharacterCount} ${css.content}`}>
            <div className="flex flex-col items-start w-full grow">
              <div
                className={`text-lg text-gray-900 ${isFullText ? '' : css.truncate}`}
                dangerouslySetInnerHTML={{ __html: content }}
              />
              <div className="w-full mt-6 md:w-64">
                <Link onClick={() => setIsFullText(!isFullText)}>{readMoreText}</Link>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CollapsibleRichText;
